import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectTemplateDefinitionState } from './project-template-definition.reducer';

export const ProjectTemplateDefinitionKey = 'projectTemplateDefinition';

export const getProjectTemplateDefinitionState =
  createFeatureSelector<ProjectTemplateDefinitionState>(ProjectTemplateDefinitionKey);

export const getProjectTemplateDefinition = createSelector(
  getProjectTemplateDefinitionState,
  (state) => state.templateDefinition,
);

export const getProjectTemplateDefinitionErrorCode = createSelector(
  getProjectTemplateDefinitionState,
  (state) => state.apiErrorCode,
);

export const getProjectTemplateDefinitionErrorDescription = createSelector(
  getProjectTemplateDefinitionErrorCode,
  (statusCode) => {
    if (statusCode === null) {
      return null;
    }

    switch (statusCode) {
      case 404:
        return 'Sorry, this template is not available';
      default:
        return 'Could not load template - please try again';
    }
  },
);
